/** App Store Connect content rights declaration values. */
export const CONTENT_RIGHTS_OPTIONS = [
  {
    value: 'DOES_NOT_USE_THIRD_PARTY_CONTENT',
    labelKey: 'panel.contentRightsDoesNotUse',
  },
  {
    value: 'USES_THIRD_PARTY_CONTENT',
    labelKey: 'panel.contentRightsUses',
  },
] as const;

/** Age rating preset profiles synced to App Store Connect. */
export const AGE_RATING_PROFILES = [
  {
    value: 'standard_4_plus',
    labelKey: 'panel.ageRatingStandard4Plus',
    descKey: 'panel.ageRatingStandard4PlusDesc',
  },
  {
    value: 'social_12_plus',
    labelKey: 'panel.ageRatingSocial12Plus',
    descKey: 'panel.ageRatingSocial12PlusDesc',
  },
  {
    value: 'mature_17_plus',
    labelKey: 'panel.ageRatingMature17Plus',
    descKey: 'panel.ageRatingMature17PlusDesc',
  },
  {
    value: 'kids',
    labelKey: 'panel.ageRatingKids',
    descKey: 'panel.ageRatingKidsDesc',
  },
] as const;

export const DEFAULT_CONTENT_RIGHTS = 'DOES_NOT_USE_THIRD_PARTY_CONTENT';
export const DEFAULT_AGE_RATING_PROFILE = 'standard_4_plus';

/** App Store Connect top-level category IDs (appCategories). */
export const IOS_APP_CATEGORIES = [
  { value: 'BOOKS', label: 'Books' },
  { value: 'BUSINESS', label: 'Business' },
  { value: 'DEVELOPER_TOOLS', label: 'Developer Tools' },
  { value: 'EDUCATION', label: 'Education' },
  { value: 'ENTERTAINMENT', label: 'Entertainment' },
  { value: 'FINANCE', label: 'Finance' },
  { value: 'FOOD_AND_DRINK', label: 'Food & Drink' },
  { value: 'GAMES', label: 'Games' },
  { value: 'GRAPHICS_AND_DESIGN', label: 'Graphics & Design' },
  { value: 'HEALTH_AND_FITNESS', label: 'Health & Fitness' },
  { value: 'LIFESTYLE', label: 'Lifestyle' },
  { value: 'MAGAZINES_AND_NEWSPAPERS', label: 'Magazines & Newspapers' },
  { value: 'MEDICAL', label: 'Medical' },
  { value: 'MUSIC', label: 'Music' },
  { value: 'NAVIGATION', label: 'Navigation' },
  { value: 'NEWS', label: 'News' },
  { value: 'PHOTO_AND_VIDEO', label: 'Photo & Video' },
  { value: 'PRODUCTIVITY', label: 'Productivity' },
  { value: 'REFERENCE', label: 'Reference' },
  { value: 'SHOPPING', label: 'Shopping' },
  { value: 'SOCIAL_NETWORKING', label: 'Social Networking' },
  { value: 'SPORTS', label: 'Sports' },
  { value: 'STICKERS', label: 'Stickers' },
  { value: 'TRAVEL', label: 'Travel' },
  { value: 'UTILITIES', label: 'Utilities' },
  { value: 'WEATHER', label: 'Weather' },
] as const;

export type IOSAppCategoryValue = (typeof IOS_APP_CATEGORIES)[number]['value'];

const iosCategorySet = new Set<string>(IOS_APP_CATEGORIES.map(c => c.value));

export function isValidIOSAppCategory(value: string | undefined | null): boolean {
  return Boolean(value && iosCategorySet.has(value));
}
